import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { ModalProps } from "../types";
import CustomButton from "./custom-button";

export default function Modals({
  showDialog,
  onCloseDialog,
  title,
  width,
  height,
  isLoading,
  className,
  children,
  centerTitle,
  backButton,
}: ModalProps) {
  const navigate = useNavigate();
  const getStyles = () => {
    const styles: React.CSSProperties = {};

    if (width) {
      styles.width = `${width}px`;
    }

    if (height) {
      styles.height = `${height}px`;
    }

    return styles;
  };
  return (
    <div className="bg-background max-h-[90vh] overflow-y-auto fixed w-full">
      {backButton ? (
        <div
          style={getStyles()}
          className="bg-transparent block mx-auto mt-8"
          onClick={() => navigate(-1)}
        >
          {" "}
          <CustomButton
            className="text-label-muted !px-0 bg-transparent font-medium hover:text-text-primary transition-colors"
            renderLeftIcon={
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-label-muted text-base flex justify-center"
              />
            }
          >
            Back
          </CustomButton>
        </div>
      ) : null}
      <div
        style={getStyles()}
        className="bg-surface border border-edge block mx-auto mt-6 mb-10 z-10 rounded-2xl shadow-card overflow-hidden"
      >
        {centerTitle ? (
          <div className="flex items-center px-6 pt-6 pb-5 text-[19px] font-bold text-heading-color tracking-tight">
            {title}
          </div>
        ) : null}
        <hr className="border-t border-edge-faint" />
        <div>{children}</div>
      </div>
    </div>
  );
}
